import Authorization from "./components/Authorization";
export default Authorization;
